// extracted by mini-css-extract-plugin
export default {"label":"_1fib1","selectsContainer":"_3PB1f","select":"_1sYNF","errorMessage":"_3r5u4"};